import React from "react"
import ReactDOM from "react-dom"
import ArrivalsDeparturesListSearch from "./arrivals-departures-list-search"

export default class ArrivalsDeparturesListSearchModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }
  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ArrivalsDeparturesListSearch {...self.modelJson} />, self.elem)
  }
}
